import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-accent)]/50 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-main)] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[var(--brand-primary)] text-[var(--text-inverse)] shadow-md hover:bg-[var(--brand-accent)] dark:text-[var(--text-primary)]",
        destructive:
          "bg-[var(--status-critical)] text-white shadow-md hover:bg-[var(--status-critical)]/90",
        outline:
          "border border-[var(--brand-accent)] bg-transparent text-[var(--brand-accent)] hover:bg-[var(--brand-accent)]/10",
        secondary:
          "bg-[var(--bg-elevated)] text-[var(--text-secondary)] shadow-sm hover:bg-[var(--brand-primary)] hover:text-[var(--text-inverse)] dark:hover:text-[var(--text-primary)]",
        ghost: "text-[var(--text-secondary)] hover:bg-[var(--bg-elevated)] hover:text-[var(--text-primary)]",
        link: "text-[var(--brand-accent)] underline-offset-4 hover:underline hover:text-[var(--brand-accent-light)]",
        success:
          "bg-[var(--status-success)] text-white shadow-md hover:bg-[var(--status-success)]/90",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-lg px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
